// eslint-disable-next-line no-restricted-imports
import { Box, Flex, GridAlpha } from '@applyboard/crystal-ui';
import { useSetPageMeta } from '@applyboard/ui-utils';
import ThreeSixtySolutionsDesktopLogo from '../../assets/ThreeSixtySolutionsDesktopLogo.png';
import ThreeSixtySolutionsMobileLogo from '../../assets/ThreeSixtySolutionsMobileLogo.png';
import { InProductFeedBackDialog } from '../../components/InProductFeedBack';
import StudentServiceListings from './StudentServiceListings/StudentServiceListings';
const TITLE = 'Student 360 Solutions';
const StudentVasHubPage = () => {
  useSetPageMeta({ title: TITLE });

  return (
    <div>
      <GridAlpha columns="repeat(27, 1fr)" rowGap={4} pb={6}>
        <GridAlpha.Item columnStart={2} columnEnd={27}>
          <Flex justify="between" align="center" wrap={true} gap={2}>
            <Box>
              <Box hideBelow="sm">
                <img
                  src={ThreeSixtySolutionsDesktopLogo}
                  alt="360 Solutions"
                  height="50px"
                  width="auto"
                />
              </Box>
              <Box hideAbove="sm">
                <img
                  src={ThreeSixtySolutionsMobileLogo}
                  alt="360 Solutions"
                  height="50px"
                  width="auto"
                />
              </Box>
            </Box>
            <Flex direction="row" gap={4} justify="start" align="center">
              <InProductFeedBackDialog />
            </Flex>
          </Flex>
        </GridAlpha.Item>
        <GridAlpha.Item columnStart={2} columnEnd={27}>
          <StudentServiceListings />
        </GridAlpha.Item>
      </GridAlpha>
    </div>
  );
};

export default StudentVasHubPage;
